@let isLoadingValue = loading();
@let activeThemeValue = activeTheme();

<div
  kdsMenuKeyboardNavigation
  class="theme-options-list"
  role="menu"
  [class.theme-options-list--disabled]="isLoadingValue"
  [attr.aria-label]="'profile-menu.theme' | translate"
>
  @if (isLoadingValue) {
    <kds-spinner variant="absolute" />
  }

  @for (option of themeOptions; track option.preference) {
    @let isActiveOption = activeThemeValue === option.preference;

    <div
      class="theme-options-list__option"
      role="menuitemradio"
      tabindex="0"
      [class.theme-options-list__option--active]="isActiveOption"
      [attr.aria-checked]="isActiveOption"
      (click)="selectTheme(option.preference)"
      (keydown.enter)="selectTheme(option.preference)"
      (keydown.space)="selectTheme(option.preference)"
    >
      <span>{{ option.labelTranslateKey | translate }}</span>
      @if (isActiveOption) {
        <i aria-hidden="true" class="fa-solid fa-check theme-options-list__check"></i>
      }
    </div>
  }
</div>
